// @ts-nocheck
import EventEmitter from 'eventemitter3';

export type AbstractAdapterOptions = {
    protocol?: string
}
export default class AbstractAdapter extends EventEmitter {
  

    constructor({protocol}: AbstractAdapterOptions) {
        super();
        this.protocol = protocol 
        this._initializeChannelMessage()
    }

    _initializeChannelMessage(){}
}
